import React, { Component } from 'react';
import {numberParce} from '../../../../server/util'
import '../dashboardItems.css'
class TotalStudents extends Component {
    constructor(props){
        super(props);
    }
    render() {
        const {data}=this.props
        return (
            <div className='panel bg-1'>                                    
                <div className='panel-body text-center'>
                    <div className="mini-stat bg-1 clearfix rounded">
                        <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-users fg-1"></i></span>
                        <div className="mini-stat-info" style={{fontSize:'18px'}}>
                            <div style={{fontSize: '18px', padding: '10px 0px'}}>Total Active Students</div>
                            <div style={{ padding: '3px 0px'}}>
                                {data.loading?<span className='loading'></span>:<span>{numberParce((data.data||{}).totalCount)}</span>}
                            </div>            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default TotalStudents;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalStudents.jsx